import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/* eslint-disable jsx-a11y/label-has-associated-control, jsx-a11y/label-has-for */


import clsx from 'clsx';
import { useTheme } from '@emotion/react';
import { form } from '../assets/styles/utility';
import FormChoiceLabel from './FormChoiceLabel';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const StylesRadioVariables = {
  size: 22,
  iconSize: 10
};
export const StylesRadioBase = (theme, props = {}) => [form.base(theme), // 1. Style
// 2. Make box Make box more robust so it clips the child element
// 3. Remove default style
// 4. Fix background on iOS
{
  // 1
  width: StylesRadioVariables.size,
  height: StylesRadioVariables.size,
  borderRadius: theme.borderRadius.rounded,
  border: theme.border.base,
  boxShadow: theme.boxShadow.base,
  position: 'relative',
  verticalAlign: 'middle',
  transition: `border-color ${theme.timing.base} ${theme.transition.base}, background ${theme.timing.base} ${theme.transition.base}`,
  // 2
  overflow: 'hidden',
  // 3
  appearance: 'none',
  // 4
  backgroundColor: theme.color.light.base,
  '&::after': {
    content: "''",
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: StylesRadioVariables.iconSize,
    height: StylesRadioVariables.iconSize,
    borderRadius: theme.borderRadius.rounded,
    border: '1px solid',
    borderColor: theme.color.primary.dark,
    backgroundColor: theme.contrast.base,
    zIndex: 1,
    opacity: 0,
    transition: `opacity ${theme.timing.base} ${theme.transition.base}`
  },
  '&:not(:disabled)': {
    cursor: 'pointer'
  },
  '&:disabled': {
    backgroundColor: theme.color.panel.base
  },
  '&:checked': {
    backgroundColor: theme.color.primary.base,
    color: theme.contrast.base,
    borderColor: theme.color.primary.dark,
    '&::after': {
      opacity: 1
    }
  }
}, theme.settings.contrast.enable && theme.settings.contrast.form && !props.noContrast && {
  '.u-contrast &': {
    borderColor: theme.contrast.base,
    backgroundColor: 'transparent',
    '&:disabled': {
      backgroundColor: form.variables(theme).contrast.background
    },
    '&:checked': {
      backgroundColor: 'transparent',
      '&::after': {
        border: 0
      }
    }
  }
}];

var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
} : {
  name: "x2ns1t-Radio",
  styles: "display:flex;align-items:center;label:Radio;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

const Radio = _ref => {
  let {
    className,
    disabled,
    label,
    name,
    value,
    noContrast,
    onChange,
    wrapperProps
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["className", "disabled", "label", "name", "value", "noContrast", "onChange", "wrapperProps"]);

  const theme = useTheme();
  return ___EmotionJSX(FormChoiceLabel, _extends({
    label: label,
    disabled: disabled,
    className: clsx('CK__Radio', className)
  }, wrapperProps), ___EmotionJSX("div", {
    css: _ref2
  }, "\u200B", ___EmotionJSX("input", _extends({
    type: "radio",
    name: name,
    disabled: disabled,
    value: value,
    onChange: onChange,
    css: [StylesRadioBase(theme, {
      noContrast
    }), process.env.NODE_ENV === "production" ? "" : ";label:Radio;"]
  }, rest))), label && ___EmotionJSX("span", null, label));
};

export default Radio;